import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import styles from "./Blog.module.css";
import { blogDateTimeAttr, formatBlogDate } from "./blogUtils";
import logoWhite from "../../../assets/logos/Logo_Gold.png";

/** Portada del artículo o, si no tiene, un encabezado dorado/navy con el logo. */
export function BlogCover({ post, className = "", eager = false }) {
  const desktop = post?.cover_image;
  const mobile = post?.cover_image_mobile;

  if (!desktop && !mobile) {
    return (
      <div className={`${styles.coverFallback} ${className}`} aria-hidden="true">
        <img src={logoWhite} alt="" className={styles.coverFallbackLogo} />
      </div>
    );
  }

  return (
    <picture className={`${styles.cover} ${className}`}>
      {mobile && desktop && <source media="(max-width: 640px)" srcSet={mobile} />}
      <img
        src={desktop || mobile}
        alt=""
        className={styles.coverImg}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
    </picture>
  );
}

/**
 * Tarjeta de artículo (listado del blog y teaser del home).
 * @param {object} props
 * @param {object} props.post
 * @param {"h2"|"h3"} [props.headingLevel]
 */
const BlogCard = ({ post, headingLevel = "h2" }) => {
  const Heading = headingLevel;
  const href = `/blog/${encodeURIComponent(post.slug)}`;
  const date = formatBlogDate(post.published_at);

  return (
    <article className={styles.card}>
      <Link to={href} className={styles.cardCoverLink} tabIndex={-1} aria-hidden="true">
        <BlogCover post={post} className={styles.cardCover} />
      </Link>
      <div className={styles.cardBody}>
        <div className={styles.cardMeta}>
          {post.category && <span className={styles.category}>{post.category}</span>}
          {date && (
            <time dateTime={blogDateTimeAttr(post.published_at)} className={styles.date}>
              {date}
            </time>
          )}
        </div>
        <Heading className={styles.cardTitle}>
          <Link to={href} className={styles.cardTitleLink}>
            {post.title}
          </Link>
        </Heading>
        {post.excerpt && <p className={styles.cardExcerpt}>{post.excerpt}</p>}
        <Link
          to={href}
          className={styles.readMore}
          aria-label={`Leer más: ${post.title}`}
        >
          <span className={styles.readMoreText}>Leer más</span>
          <FontAwesomeIcon icon={faArrowRight} className={styles.readMoreIcon} />
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;
